import { ProgramsLayout } from '@components/buzzkuri/shared/layouts/Programs'
import { InitProgramNavList } from '@context/ProgramNavList/InitProgramNavList'
import { ProgramsCategoryPageResAndSlugs } from '@type/buzzkuri/programs-categor'
import { ProgramCategory } from './ProgramCategory'
import { ProgramCross } from './ProgramCross'

export const ProgramsSlugsPage = ({
  slugs,
  programsSlugsPageRes,
  programCategoryList,
}: ProgramsCategoryPageResAndSlugs): JSX.Element => {
  const { business, pageContent } = programsSlugsPageRes
  const { totalProgramCount, programCategories } = pageContent
  InitProgramNavList({ totalProgramCount, programCategories })

  return (
    <ProgramsLayout {...{ business }}>
      <>
        {programCategoryList && (
          <>
            {slugs.length === 1 ? (
              programCategoryList.tags.filter(({ name }) => name === slugs[0])
                .length > 0 ? (
                <ProgramCross {...{ pageContent, slugs }} />
              ) : (
                <ProgramCategory {...{ slugs, pageContent }} />
              )
            ) : (
              <ProgramCross {...{ pageContent, slugs }} />
            )}
          </>
        )}
      </>
    </ProgramsLayout>
  )
}
